import { render, staticRenderFns } from "./FormUpdateProfile.vue?vue&type=template&id=2f01ce44&scoped=true"
import script from "./FormUpdateProfile.vue?vue&type=script&lang=js"
export * from "./FormUpdateProfile.vue?vue&type=script&lang=js"
import style0 from "./FormUpdateProfile.vue?vue&type=style&index=0&id=2f01ce44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01ce44",
  null
  
)

export default component.exports